import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AIImage from "./pages/AIImage";
import AIVideo from "./pages/AIVideo";
import Pricing from "./pages/Pricing";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/image">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ai-image" element={<AIImage />} />
          <Route path="/ai-video" element={<AIVideo />} />
          <Route path="/pricing" element={<Pricing />} />
        </Routes>
        <Footer />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;